export default "__VITE_ASSET__b5773afd__"